(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lw-set-info"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lw-set-view'))customElements.define('lw-set-view',class extends HTMLElement{
connectedCallback(){
this.connect=()=>{
if(this.unsubscribe||typeof subscribe!=='function')return;
this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
if(!event?.data?.variant?.id)return;
const template=this.querySelector('template[data-set-variant="'+event.data.variant.id+'"]');
if(template)this.querySelector('[data-set-active]').replaceChildren(template.content.cloneNode(true));
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.connect,{once:true});else this.connect();
}
disconnectedCallback(){this.unsubscribe?.();document.removeEventListener('DOMContentLoaded',this.connect);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sasstie-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sasstie-product-info')) {
    customElements.define('sasstie-product-info', class extends HTMLElement {
      connectedCallback() {
        if (this.variantUnsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
          if (!data || String(data.sectionId) !== this.dataset.sectionId) return;
          const incoming = data.html?.querySelector(`sasstie-product-info[data-product-id="${this.dataset.productId}"]`);
          const source = incoming?.querySelector('[data-sasstie-material]');
          const target = this.querySelector('[data-sasstie-material]');
          if (source && target) target.innerHTML = source.innerHTML;
        });
      }
      disconnectedCallback() {
        this.variantUnsubscribe?.();
        this.variantUnsubscribe = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
